import { SidebarLink } from 'types/SidebarLink'
import { HOME_KEY } from './constants'

const redirect = (
  links: SidebarLink[],
  subTabIndex: number,
  subTabSubOptionIndex: number,
  route: any,
  history: any,
): void => {
  const isASubOption = subTabSubOptionIndex >= 0
  const linkIsATitle = links[subTabIndex].to === undefined

  if (isASubOption) {
    const subOptions = links[subTabIndex].subOptions

    if (subOptions !== undefined) {
      history.push(`${route.url}${subOptions[subTabSubOptionIndex].to}`)

      return
    }
  }

  if (linkIsATitle) {
    // This should not happen, it's a safeguard if the links contains only a title
    // so we don't redirect to /undefined
    const lastLinkIsATitle = subTabIndex + 1 === links.length

    if (lastLinkIsATitle) {
      history.push(`${route.url}${HOME_KEY}`)
      return
    }

    history.push(`${route.url}${links[subTabIndex + 1].to}`)
    return
  }

  history.push(`${route.url}${links[subTabIndex].to}`)
}

export default redirect
